import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import useLangTranslation from "../../../customHooks/languageProvider";
import { useSelector } from "react-redux";

const ChooseLanguage = ({
    showModal,
    closeModal,
    selectedItemId,
    setSelectedItemId,
    handleSave
}) => {
    const modalRef = useRef();
    const { getLangTranslation } = useLangTranslation();
    const { languageList } = useSelector(({ misc }) => misc);

    useEffect(() => {
        if (showModal) {
            const modal = new Modal(modalRef.current, {
                backdrop: "static",
                keyboard: false,
            });
            modal.show();
        }
    }, [showModal]);

    const { appLanguageId } = useSelector(({ misc }) => misc);

    const lang = languageList.find((item) => item?.id === appLanguageId);
    // const lang = AdminSetRuleLanguage?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);

    return (
        <>
            <div className="modal fade" tabIndex="-1" ref={modalRef}>
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <h6 className="modal-title text-blue-900">{getLangTranslation("YOUTUBE_SEARCH_KEYWORD_CHOSE_LANGUAGE_TITLE", "Choose language")}</h6>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={closeModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className={`my-5 py-3 ${lang?.isRTL === 1 ? 'ps-3' : ' pe-3'}`} style={{ maxHeight: '40vh', overflow: 'auto' }}>
                                {
                                    languageList?.map((item) => {
                                        return (
                                            <label
                                                htmlFor={item?.id}
                                                className="d-flex gap-4 align-items-center mb-6 pt-cursor"
                                                key={item?.Language}
                                            >
                                                <img src={item?.icon} alt="flag" />
                                                <h5 className="text-blue-900 mb-0 flex-fill">{item?.Language}</h5>
                                                <input
                                                    className="form-check-input m-0"
                                                    type="radio"
                                                    value={item?.id}
                                                    id={item?.id}
                                                    name="LANGUAGE"
                                                    checked={parseInt(selectedItemId) === parseInt(item?.id)}
                                                    onChange={() => setSelectedItemId(item?.id)}
                                                />
                                            </label>
                                        )
                                    })
                                }
                            </div>
                            <div className="grid gap-3">
                                <button
                                    className="btn btn-outline-primary g-col-6"
                                    type="button"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={closeModal}
                                >
                                    <span className="btn-upper-case" >
                                        {getLangTranslation("CANCEL", "Cancel")}
                                    </span>
                                </button>
                                <button
                                    className="btn btn-primary g-col-6"
                                    type="button"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleSave}
                                >
                                    <span className="btn-upper-case">
                                        {getLangTranslation("SAVE", "Save")}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChooseLanguage